module.exports = __webpack_public_path__ + "img/status_3.281d099a.svg";